import { render, staticRenderFns } from "./countryFlag.vue?vue&type=template&id=254458d8&scoped=true&"
import script from "./countryFlag.vue?vue&type=script&lang=js&"
export * from "./countryFlag.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./countryFlag.vue?vue&type=style&index=0&id=254458d8&scoped=true&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "254458d8",
  null
  ,true
)

export default component.exports